import { Component, computed, input, model, ChangeDetectionStrategy } from '@angular/core';

import { NumpadComponent } from '../../numpad/numpad.component';
import { ResolvableModal } from '@softline/ui-core';
@Component({
  selector: 'soft-numpad-modal',
  imports: [NumpadComponent],
  templateUrl: './numpad-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './numpad-modal.component.css',
})
export class NumpadModalComponent extends ResolvableModal<number> {
  value = model<number>(0);
  quickNumbers = input<number[]>([]);
  unit = input<string | null>(null);
  heightPx = input<number | null>(null);
  min = input<number>(0);
  max = input<number>(1000000);
  floatingPoints = input<number>(2);
  selectExistingInput = input<boolean>(false);

  height = computed(() => {
    const height = this.heightPx();
    return height ? height : 64;
  });

  save(value: number) {
    this.resolve(value);
  }
}
